//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Alvarado_info',
  data () {
    return {
    }
  },
  components: {
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pedi/Alvarado_info.vue